import React, { useState, useRef, useEffect } from "react";
import classNames from "classnames";
import "./index.scss";

interface IContentProps {
  contentText: string;
  className?: string;
}

/**
 * 可折叠文本：折叠态最多展示 2 行（超出省略并显示展开箭头），点击展开/收起。
 * 采用正常文档流 + -webkit-line-clamp，内容随行数撑高所在行，长文本不会溢出遮挡相邻内容；
 * 连续无空格串（数字/字母）用 word-break/overflow-wrap 强制换行。
 */
export default function CollapseContent(props: IContentProps) {
  const { contentText, className } = props;
  const [expanded, setExpanded] = useState(false);
  const [overflow, setOverflow] = useState(false);
  const textRef = useRef<HTMLDivElement | null>(null);

  // 折叠态下测量是否溢出（完整高度 > 截断高度）决定是否显示展开箭头
  useEffect(() => {
    const el = textRef.current;
    if (!el) return;
    setOverflow(el.scrollHeight > el.clientHeight + 1);
  }, [contentText]);

  return (
    <div
      className={classNames("collapse-content", className)}
      onClick={() => overflow && setExpanded((e) => !e)}
    >
      <div
        ref={textRef}
        className={classNames("content-text", { "expand-text": expanded })}
      >
        {contentText}
      </div>
      {overflow && (
        <i
          className={classNames("arrow-down-icon", { expanding: expanded })}
        />
      )}
    </div>
  );
}
